
import { CertificateReport } from "./components/certificate-report/certificate-report"

export const App = () => (
      <CertificateReport />
)
